var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.users'),"text":_vm.$t('users.description'),"name":"customers","url":_vm.$listRoutes.customers,"table":_vm.customers,"filters":_vm.customersFilters,"fields":_vm.fields,"search":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }